"use client";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenu } from "@speakai/ui/dropdown-menu";
import { Languages } from "lucide-react";
import { changeLanguage } from "@/lib/integrations/i18n";
import { LanguageList } from "@/components/layout/language-list";

/**
 * Language selector dropdown.
 */
export function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSelect = async (code: string) => {
    setOpen(false);
    await changeLanguage(code);
  };

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      trigger={
        <button
          className="hidden md:flex items-center justify-center w-8 h-8 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          aria-label={t("TRANSLATOR.SELECT")}
        >
          <Languages className="h-4.5 w-4.5" />
        </button>
      }
      align="right"
      width="w-[220px]"
    >
      <LanguageList currentLang={i18n.language || "en"} changingLanguage={null} onSelectLanguage={handleSelect} />
    </DropdownMenu>
  );
}
